import { ref, computed } from '@vue/composition-api';
import { intersection } from 'lodash';
import { execute as refinement, state as refinementState } from './refinement';
import { execute as select, state as selectState } from './select';
import { execute as query, state as queryState } from './query';

export const items = ref([]);

export const results = computed(() => {
    const subset = query(items.value, queryState.value);
    const filtered = [];

    filtered.push(refinement(subset, refinementState.value));
    filtered.push(select(subset, selectState.value));
    return intersection(...filtered);
});

export const init = async ({ dataset }) => {
    items.value = dataset;
    return results;
};
